import { useEffect, useState } from 'react'
import { Button } from '@/common/ui/button'
import { Modal } from '@/common/ui/modal'

interface AlertModalProps {
	isOpen: boolean
	onClose: () => void
	onConfirm: () => void
	loading: boolean
}

export const AlertModal: React.FC<AlertModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
	loading,
}) => {
	const [isMounted, setIsMounted] = useState(false)

	useEffect(() => {
		setIsMounted(true)
	}, [])

	if (!isMounted) {
		return null
	}

	return (
		<Modal
			title="ยืนยันการลบ"
			description="คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้? การดำเนินการนี้ไม่สามารถย้อนกลับได้"
			isOpen={isOpen}
			onClose={onClose}
		>
			<div className="flex w-full items-center justify-end space-x-2 pt-6">
				<Button disabled={loading} variant="outline" onClick={onClose}>
					ยกเลิก
				</Button>
				<Button disabled={loading} variant="destructive" onClick={onConfirm}>
					ลบ
				</Button>
			</div>
		</Modal>
	)
}
